'use strict';
import React from 'react';
import ReactDOM from 'react-dom';
import {googlePlusShareThisPage} from './google-plus.js';
const screen = require('./screen.js');

class MenuDocument extends React.Component {
  createDocumentDetails() {
    if (this.props.routerLocation.type === 'document') {
      let pdf = document.getElementById('pdf-viewer');
      return (
        <div>
          <h1 className="title">{pdf.getAttribute('data-title')}</h1>
          <p className="author no-margin">Author: {pdf.getAttribute('data-author')}</p>
          <p className="year no-margin">Year: {pdf.getAttribute('data-year')}</p>
          <p className="submitted-by no-margin">Submitted by: {pdf.getAttribute('data-submitted-by')}</p>
          <p className="tags">Tags: {pdf.getAttribute('data-tags').split(',').join(', ')}</p>
          <p className="no-margin tags"><a className="link" href={pdf.getAttribute('data-src')} download>• Download PDF</a></p>
          <p className="no-margin tags"><a className="link" href={`mailto:?subject=${pdf.getAttribute('data-title') + ' PDF'}&body=View it at:%0D%0A${document.location.href}`} target="_blank">• Email</a></p>
          <p className="no-margin link facebook-link" data-href={document.location.href}>• Facebook</p>
          <p className="no-margin"><a className="link" href={`https://twitter.com/intent/tweet?text=${pdf.getAttribute('data-title')}&amp;url=${document.location.href}`}>• Twitter</a></p>
          <p><a className="link" href={`https://plus.google.com/share?url=${document.location.href}`} onClick={googlePlusShareThisPage}>• Google+</a></p>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="document" style={{display: ((this.props.routerLocation.type === 'document') && (!screen.isMobile() && !screen.isTablet())) ? 'block': 'none'}}>
        <h1 style={{marginBottom: '38px'}}><a className="menu-link inner-page-link desktop" href="/library" data-type="library" data-page="library" onClick={this.props.toggleMobileMenu}>All Conference</a></h1>
        {this.createDocumentDetails()}

        <h1 style={{marginBottom: '24px', position: 'absolute', bottom: 0}}><a className="menu-link inner-page-link desktop" href="/library" data-type="library" data-page="library" onClick={this.props.toggleMobileMenu}>Back to Library</a></h1>
      </div>
    )
  }
}

module.exports = MenuDocument;



// WEBPACK FOOTER //
// ./src/js/menu-document.jsx